import type { MetadataTemplateField, MetadataTemplateOption } from '@openapi'

export function getComponentNameByFilterType(type: string) {
  switch (type) {
    case 'date':
      return 'CDateRangeFilter'
    case 'checkbox':
    case 'multi-select':
    case 'select':
      return 'CSelectFilter'
    default:
      return 'CSearchFilter'
  }
}

export default function useMetadataFilters(t: (input: string) => string) {
  function getBooleanOptions(availableValues?: Array<string | boolean | number>) {
    if (availableValues && Array.isArray(availableValues)) {
      return availableValues.map((value) => {
        const boolValue = typeof value === 'string' ? value : String(value)
        return {
          label: boolValue === 'true' ? t('canvasUI.common.yes') : t('canvasUI.common.no'),
          value: boolValue,
        }
      })
    }

    return [
      { label: t('canvasUI.common.yes'), value: 'true' },
      { label: t('canvasUI.common.no'), value: 'false' },
    ]
  }

  function getDefaultDateOptions(): MetadataTemplateOption[] {
    return [
      {
        label: t('canvasUI.components.canvases.CCanvasMetadataFilters.lastWeek'),
        value: 'last_week',
      },
      {
        label: t('canvasUI.components.canvases.CCanvasMetadataFilters.lastMonth'),
        value: 'last_month',
      },
    ]
  }

  function getFilterOptions(
    type: MetadataTemplateField['type'],
    options: MetadataTemplateField['options'],
    availableValues?: Array<string | boolean | number>,
  ): MetadataTemplateOption[] {
    if (type === 'checkbox') return getBooleanOptions(availableValues)
    else if (type === 'date') return getDefaultDateOptions()
    else return options ?? []
  }

  return { getBooleanOptions, getComponentNameByFilterType, getDefaultDateOptions, getFilterOptions }
}
